import { isFeatureEnabled } from 'owa-feature-flags';
import { setIsDeepLinkAction } from 'owa-calendar-actions';
import { lazyOpenBoardEditorDialog } from 'owa-calendar-board-editor';
import { BOARD_VIEW_ROUTE_KEYWORD, NEW_ROUTE_KEYWORD } from '../constants';

/**
 * Route handler for board view content
 */
export default function boardViewRouteHandler() {
    const path = location.pathname.split('/');
    setIsDeepLinkAction(true);

    if (
        !path.includes(BOARD_VIEW_ROUTE_KEYWORD) ||
        !isFeatureEnabled('cal-board-multipleBoards-dev')
    ) {
        return;
    }

    if (path.includes(NEW_ROUTE_KEYWORD)) {
        lazyOpenBoardEditorDialog.importAndExecute();
    }
}
